<template>
  <app-chart chartType="line" v-if="chartOptions"
    :chartOptions="chartOptions"
    :height="170">
  </app-chart>
</template>

<script>
import { parse, format } from 'date-fns'
import { thousand } from '@/libs/utils'
import { getTooltipHtml } from '@/libs/chart-helper'
import AppChart from '@/components/chart'

function msToMinSec (ms) {
  const sec = Math.round(ms / 1000)
  return `${Math.floor(sec / 60)}m ${sec % 60}s`
}

export default {
  name: 'SimpleAnalytics',
  components: {
    AppChart
  },
  props: [
    'type',
    'name',
    'dailyData',
    'color'
  ],
  computed: {
    ySplitNumber () {
      switch (this.type) {
        case 'avgDuration':
        case 'exitRate':
          return 2
        default:
          return 2
      }
    },
    yLabelFormatter () {
      if (this.type === 'avgPvPerUv') {
        return function (value) {
          return value.toFixed(1)
        }
      } else if (this.type === 'exitRate') {
        return '{value}%'
      } else if (this.type === 'avgDuration') {
        return function (value) {
          return msToMinSec(value)
        }
      } else {
        return '{value}'
      }
    },
    tooltipFormatter () {
      return function (params) {
        const item = params[0]
        const title = format(parse(item.axisValue), 'MM-DD')
        let seriesName = item.seriesName
        let value = item.value[1]

        if (this.type === 'avgDuration') {
          value = msToMinSec(value)
        } else if (this.type === 'avgPvPerUv') {
          seriesName = seriesName.replace(/\s/g, '')
        } else if (this.type === 'exitRate') {
          value = value + '%'
          seriesName = seriesName.replace('(%)', '')
        } else if (this.type === 'pv') {
          value = thousand(value)
        }

        const content = [
          [`${item.marker}${seriesName} : `, value]
        ]
        return getTooltipHtml(content, title)
      }.bind(this)
    },
    chartOptions () {
      const data = this.dailyData.map(item => {
        return [
          item.timestamp,
          item[this.type]
        ]
      })

      const options = {
        meta: {
          isDailyChart: true
        },
        series: [
          {
            name: this.name,
            type: 'line',
            data: data,
            showSymbol: false,
            symbolSize: 2,
            smooth: true
          }
        ],
        tooltip: {
          formatter: this.tooltipFormatter
        },
        yAxis: {
          splitNumber: this.ySplitNumber,
          axisLabel: {
            formatter: this.yLabelFormatter
          }
        },
        color: [this.color]
      }

      if (this.type === 'exitRate') {
        options.yAxis.max = 100
      }

      return options
    }
  }
}
</script>

<style>

</style>
